const AUTH_KEY = 'admin_auth_token';

export const authService = {
  setAuthToken(token: string): void {
    localStorage.setItem(AUTH_KEY, token);
  },

  getAuthToken(): string | null {
    return localStorage.getItem(AUTH_KEY);
  },

  removeAuthToken(): void {
    localStorage.removeItem(AUTH_KEY);
  },

  isAuthenticated(): boolean {
    return !!this.getAuthToken();
  }
}; 